export const hasAnyDetailValue = (
	...values: (string | number | null | undefined)[]
) =>
	values.some((value) => value !== null && value !== undefined && value !== "");
